export interface PowerManagementItem {
  id: number;
  name: string;
  noOfItems: string | number;
  powerConsumptions: string | number;
  typeOfPower: string;
  makerModel: string;
}

export const powerManagementInit = [
  {
    id: 1,
    name: "Ballast Pumps",
    makerModel: "",
    noOfItems: "",
    powerConsumptions: "",
    typeOfPower: "",
  },
  {
    id: 2,
    name: "BWTS",
    makerModel: "",
    noOfItems: "",
    powerConsumptions: "",
    typeOfPower: "",
  },
  {
    id: 3,
    name: "Fire Pump",
    makerModel: "",
    noOfItems: "",
    powerConsumptions: "",
    typeOfPower: "",
  },
  {
    id: 4,
    name: "Air Conditioning Plant",
    makerModel: "",
    noOfItems: "",
    powerConsumptions: "",
    typeOfPower: "",
  },
  {
    id: 5,
    name: "Mechanical Hold Ventilation",
    makerModel: "",
    noOfItems: "",
    powerConsumptions: "",
    typeOfPower: "",
  },
  {
    id: 6,
    name: "Cargo Cranes",
    makerModel: "",
    noOfItems: "",
    powerConsumptions: "",
    typeOfPower: "",
  },
  {
    id: 7,
    name: "Electrical Power of Scrubber Installation",
    makerModel: "",
    noOfItems: "",
    powerConsumptions: "",
    typeOfPower: "",
  },
];

export interface Tq8PowerManagementM {
  auxGensetsMakerAndModel: string;
  noOFAuxGensets: string;
  auxGensetsPower: string;
  noxTierIIIComplianceMethod: string;
  shaftGeneratorFitted: string;
  shaftGeneratorRatedPower: string;
  minMainEngineMcrForShaftGenerator: string;
  auxBoilerConsumption: string;
  makerTypeHeatingCapacity: string;
  normalElectricalLoadAtSea: string;
  normalElectricalLoadinPortAtAnchor: string;
  usualWorkingElectricalLoadatSea: string;
  usualWorkingLoadPortAtAnchor: string;
  normalAEHFOConsumptionATSea: string;
  normalLoadAEFOConsumptionInPort: string;
  mormalFuelConsumptionAuxiliaryBoilerAtSeal: string;
  normalFuelConsumptionOfBoilerInPort: string;
}

export const tq8PowerManagementFormInit = {
  auxGensetsMakerAndModel: "",
  noOFAuxGensets: "",
  auxGensetsPower: "",
  noxTierIIIComplianceMethod: "",
  shaftGeneratorFitted: "",
  shaftGeneratorRatedPower: "",
  minMainEngineMcrForShaftGenerator: "",
  auxBoilerConsumption: "",
  makerTypeHeatingCapacity: "",
  normalElectricalLoadAtSea: "",
  normalElectricalLoadinPortAtAnchor: "",
  usualWorkingElectricalLoadatSea: "",
  usualWorkingLoadPortAtAnchor: "",
  normalAEHFOConsumptionATSea: "",
  normalLoadAEFOConsumptionInPort: "",
  mormalFuelConsumptionAuxiliaryBoilerAtSeal: "",
  normalFuelConsumptionOfBoilerInPort: "",
};

export function mapSqlToTq8PowerManagementForm(_powerManagement: any): Tq8PowerManagementM {
  return {
    auxGensetsMakerAndModel: _powerManagement.AUX_GENSETS_MAKER_AND_MODEL,
    noOFAuxGensets: _powerManagement.NO_OF_AUX_GENSETS,
    auxGensetsPower: _powerManagement.POWER_MGMT_AUX_GENSETS_POWER,
    noxTierIIIComplianceMethod: _powerManagement.NOX_TIER_III_COMPLIANCE_METHOD ?? "",
    shaftGeneratorFitted: _powerManagement.SHAFT_GENERATOR_FITTED,
    shaftGeneratorRatedPower: _powerManagement.SHAFT_GENERATOR_RATED_POWER,
    minMainEngineMcrForShaftGenerator: _powerManagement.MIN_MAIN_ENGINE_MCR_FOR_SHAFT_GENERATOR,
    auxBoilerConsumption: _powerManagement.AUX_BOILER_CONSUMPTION,
    makerTypeHeatingCapacity: _powerManagement.MAKER_TYPE_HEATING_CAPACITY,
    normalElectricalLoadAtSea: _powerManagement.POWER_MGMT_NORMAL_ELECTRICAL_LOAD_AT_SEA,
    normalElectricalLoadinPortAtAnchor: _powerManagement.NORMAL_ELECTRICAL_LOAD_IN_PORT_AT_ANCHOR,
    usualWorkingElectricalLoadatSea: _powerManagement.USUAL_WORKING_ELECTRICAL_LOAD_AT_SEA,
    usualWorkingLoadPortAtAnchor: _powerManagement.USUAL_WORKING_LOAD_PORT_AT_ANCHOR,
    normalAEHFOConsumptionATSea: _powerManagement.NORMAL_AEHFO_CONSUMPTION_AT_SEA,
    normalLoadAEFOConsumptionInPort: _powerManagement.NORMAL_LOAD_AE_FO_CONSUMPTION_IN_PORT ?? "",
    mormalFuelConsumptionAuxiliaryBoilerAtSeal: _powerManagement.NORMAL_FUEL_CONSUMPTION_AUXILIARY_BOILER_AT_SEA,
    normalFuelConsumptionOfBoilerInPort: _powerManagement.NORMAL_FUEL_CONSUMPTION_OF_BOILER_IN_PORT,
  };
}

export function mapSqlToTq8PowerManagementTable(powerManagementRows: any[]): PowerManagementItem[] {
  return powerManagementInit.map((item) => {
    const match = powerManagementRows.find((apiItem) => apiItem.NAME === item.name);

    return match
      ? {
          ...item,
          makerModel: match.MAKER_MODEL || "",
          noOfItems: match.NO_OF_ITEMS ?? "",
          powerConsumptions: match.POWER_CONSUMPTIONS ?? "",
          typeOfPower: match.TYPE_OF_POWER || "",
        }
      : item;
  });
}
